import _ from 'lodash';

import { InOutInputPlugin } from '../in-out-input/in-out-input.plugin';
import { IOnOff } from '../../interfaces/on-off.interface';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class BinaryInputPlugin extends InOutInputPlugin implements IOnOff {

  public getReportableAttrs() {
    return ['PresentValue'];
  }

  public getConditionOptions() {
    const inputs: any[] = _.get(this.device, 'meta.inputs', []);
    const input: any = inputs.find(
      (i: any) =>
        i.componentId === this.componentId && i.processor === this.processorName
    );
    const reversePolarity = input ? !!input.reversePolarity : false;

    return [
      {
        displayName: _.capitalize(
          _.get(
            this.translationService.getResource(),
            'AR.CONDITIONS_NL.ALARMED',
            ''
          )
        ),
        name: 'Alarmed',
        value: !reversePolarity
      },
      {
        displayName: _.capitalize(
          _.get(
            this.translationService.getResource(),
            'AR.CONDITIONS_NL.NOT_ALARMED',
            ''
          )
        ),
        name: 'Not Alarmed',
        value: reversePolarity
      }
    ];
  }

  public getConditionAttribute(): string | null {
    return 'PresentValue';
  }

  public getEffectOptions() {}

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string | null {
    return null;
  }

  public on(): void {}

  public off(): void {}

  public toggle(): void {}

  public isOn(): boolean {
    return this.state.presentValue === true;
  }

  public isOff(): boolean {
    return !this.isOn();
  }

  public getStatusPayload() {
    return ['PresentValue'];
  }

  public processMessage(message: IWebSocketDeviceMessage, timestamp?: number) {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute) {
      this.state[`${attribute[0].toLowerCase()}${attribute.substring(1)}`] =
        response.value;
      this._onUpdate.next({ state: this.state });
    }

    return this.state;
  }
}
